import { ContactsEmptyState } from '../contacts/elements/ContactsEmptyState'

export const SuppliersEmptyState = () => <ContactsEmptyState isCustomer={false} isSupplier />
